import { render } from "./distributor_target_form.vue?vue&type=template&id=23b7cc39&scoped=true"
import script from "./distributor_target_form.vue?vue&type=script&lang=js"
export * from "./distributor_target_form.vue?vue&type=script&lang=js"

import "./distributor_target_form.vue?vue&type=style&index=0&id=23b7cc39&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b7cc39"]])

export default __exports__